import React, { useEffect } from "react";

//components
import PortfolioHeading from "../Components/PortfolioHeading";
import PrevAndNextWork from "../Components/PrevAndNextWork";
import Footer from "../Components/Footer";
import gsap from "gsap";

//  assets import
// import blade_1 from "../assets/verdeAppAssets/banner.svg";
// import blade_2 from "../assets/verdeAppAssets/banner.png";
import blade_2 from "../assets/verdeAppAssets/hero.jpg";
import blade_3 from "../assets/verdeAppAssets/app-preview.jpg";
import blade_4 from "../assets/verdeAppAssets/approach.jpg";
import blade_5 from "../assets/verdeAppAssets/rephrase.jpg";
import blade_6 from "../assets/verdeAppAssets/info-architecture.jpg";

import blade_7 from "../assets/verdeAppAssets/wireframe.jpg";
import blade_8 from "../assets/verdeAppAssets/system.jpg";
import blade_9 from "../assets/verdeAppAssets/typography.jpg";
import blade_10 from "../assets/verdeAppAssets/colors-grid.jpg";
import blade_11 from "../assets/verdeAppAssets/mobile-preview.jpg";
import blade_12 from "../assets/verdeAppAssets/bottom-nav.jpg";
import blade_13 from "../assets/verdeAppAssets/list-item.jpg";
import blade_14 from "../assets/verdeAppAssets/final-outcome-screen.jpg";
import blade_15 from "../assets/verdeAppAssets/ev-chargin-location.jpg";
import blade_16 from "../assets/verdeAppAssets/screens.jpg";
import blade_18 from "../assets/verdeAppAssets/qrcode-scan-screen.jpg";
import blade_19 from "../assets/verdeAppAssets/views.jpg";
import blade_17 from "../assets/verdeAppAssets/qrcode-charging-status.jpg";
import blade_20 from "../assets/verdeAppAssets/charging-details-screen.jpg";
import blade_21 from "../assets/verdeAppAssets/user-dashboard.jpg";

//QR scanner
import barcode from "../assets/verdeAppAssets/qrscan/barcode.png";
import phonemockup from "../assets/verdeAppAssets/qrscan/phonemockup.png";
import chargingbolt from "../assets/verdeAppAssets/qrscan/chargingbolt.svg";
import scanScreen from "../assets/verdeAppAssets/qrscan/scanningScreen.png";

//images
import prevImg from "../assets/images/IP.jpg";
import nextImg from "../assets/images/ITAT.jpg";

//  atoms
import Images from "../Components/Atoms/Images";
import { flushLayout } from "framer-motion";

const VerdemobilityApp = () => {
  const Heading = ({ head, paragraph, className }) => {
    return (
      <div className={`${className} verdeapp-heading simple__width`}>
        <h3>{head}</h3>
        <h4>{paragraph}</h4>
      </div>
    );
  };

  useEffect(() => {
    const tl = gsap.timeline();

    gsap
      .timeline({
        scrollTrigger: {
          trigger: ".qr__codescanner",
          start: "top 15%",
          end: "500%",
          markers: false,
          pin: true,
          pinnedContainer: ".qr__codescanner",
          pinType: "fixed",
          scrub: true,
        },
      })
      .fromTo(
        ".qr__codescanner .barcode",
        { opacity: 0, y: 100, scale: 3, transformOrigin: "top" },
        { opacity: 1, y: 0, duration: 1, scale: 1 }
      )
      .fromTo(
        ".qr__codescanner .mock",
        { opacity: 0, y: 100, scale: 2 },
        { opacity: 1, y: 0, duration: 2, scale: 1 }
      )
      .fromTo(
        ".qr__codescanner .scanline",
        { height: 0, borderBottom: "none" },
        {
          duration: 1,
          height: 180,
          opacity: 1,
          borderBottom: "2px solid #03d078",
        }
      )
      .fromTo(
        ".qr__codescanner .chargingbolt",
        { width: "0", height: "0", opacity: 0 },
        { width: "100%", height: "100%", opacity: 1, duration: 0.5 }
      )
      .fromTo(
        ".qr__codescanner .chargingbolt .svg-green",
        { height: 0 },
        { height: "100%", duration: 1 }
      )
      .fromTo(
        ".qr__codescanner .chargingbolt",
        { scale: 1 },
        { scale: 1.1, duration: 0.5 }
      )
      .fromTo(
        ".qr__codescanner .chargingbolt .msg1",
        { opacity: 0 },
        { opacity: 1, duration: 1 }
      );
  }, []);

  return (
    <div className="portfolio__container">
      <PortfolioHeading
        heading="Verdemobility App"
        subHeading="Branding"
        info="VerdeMobility is a leading Indian manufacturer of EV Charging Infrastructure across the globe. 
        Venturing into the B2C space by setting up a vast EV charging network across India and abroad, 
        they needed a SaaS-based application design for their end users."
        infoSecondary=" Blacksof worked on the user flow, wireframe, and created a functional high-fidelity design prototype capturing more 
        than 50+ screens."
      />
      <div className="portfolio__content">
        <div className="verdeapp-wrapper">
          <div className="hero__section">
            <Images image={blade_2} />
          </div>

          <div className="top__margin">
            <Images image={blade_3} />
          </div>

          <div className="blade__margin">
            <Heading head="How we approached the problem" />
            <Images image={blade_4} className="top__margin" />
          </div>

          <div className="blade__margin">
            <Heading head="Information architecture" />
            <Images image={blade_6} className="top__margin" />
          </div>
          <div className="blade__margin">
            <Heading head="Wireframe" />
            <Images image={blade_7} className="top__margin" />
          </div>
          <div className="blade__margin">
            <Heading head="The system we built" />
            <Images image={blade_8} className="top__margin" />
          </div>

          {/* Colors */}
          <Images image={blade_9} className="top__margin" />

          {/* Typography */}
          <Images image={blade_10} className="top__margin" />
          <Images image={blade_11} className="top__margin" />

          <div className="blade__margin">
            <Heading head="App bottom navigation bar" />
            <Images image={blade_12} className="top__margin" />
          </div>

          <div className="blade__margin">
            <Heading head="List item" />
            <Images image={blade_13} className="top__margin" />
          </div>

          <div className="blade__margin">
            <Heading head="The Final Outcome" />
            <Images image={blade_14} className="top__margin" />
          </div>
          <div className="blade__margin">
            <Images image={blade_15} className="top__margin" />
            <Images image={blade_16} className="top__margin" />

            {/* <Images image={blade_18} className="top__margin" /> */}

            <div className="blade__margin">
              <div className="qr__codescanner simple__width">
                <Heading className="qrHeadingWrappers" head="QR Code" />
                <div>
                  <img
                    className="phonemockup mock"
                    src={phonemockup}
                    alt="scanner"
                  />
                  <img
                    className="scanScreen mock"
                    src={scanScreen}
                    alt="scanner"
                  />
                  <img className="barcode" src={barcode} alt="scanner" />
                  <p className="scanline"></p>
                  <div className="chargingbolt">
                    <span className="">
                      <svg
                        width="130"
                        height="196"
                        viewBox="0 0 130 196"
                        fill="#fff"
                        xmlns="http://www.w3.org/2000/svg"
                        className="svg-white"
                      >
                        <path
                          id="bolt-gradient"
                          d="M73.0705 73.4021H75.3249C90.4515 73.4021 105.571 73.4021 120.697 73.4021C122.325 73.2185 123.97 73.5187 125.429 74.2653C126.887 75.0119 128.095 76.1721 128.902 77.6016C129.709 79.0312 130.08 80.6671 129.967 82.3061C129.855 83.9451 129.266 85.515 128.272 86.8206C106.896 121.628 85.562 156.448 64.2711 191.281C63.4683 192.898 62.1708 194.214 60.5685 195.037C58.9662 195.861 57.1432 196.148 55.3665 195.857C53.655 195.552 52.0872 194.702 50.8959 193.432C49.7046 192.162 48.9534 190.541 48.7538 188.808C48.6663 187.475 48.737 186.137 48.9642 184.821C50.6875 170.02 52.4208 155.217 54.1642 140.412C54.848 134.577 55.5243 128.727 56.2306 122.613H53.9763C38.9173 122.613 23.8559 122.613 8.7919 122.613C6.72853 122.752 4.68935 122.102 3.08369 120.795C1.47802 119.487 0.424714 117.619 0.135253 115.565C-0.118795 113.32 0.473616 111.061 1.79595 109.232C12.8171 91.2658 23.8384 73.2865 34.8596 55.2948C45.1994 38.3835 55.5393 21.4848 65.8792 4.5986C66.7639 2.83917 68.2443 1.45333 70.055 0.689421C71.8658 -0.0744849 73.8885 -0.166513 75.7607 0.429832C77.5704 1.01209 79.1211 2.2092 80.1457 3.81499C81.1703 5.42078 81.6047 7.33472 81.374 9.22721C78.6488 30.0886 75.916 50.9451 73.1757 71.7964C73.1231 72.2487 73.1081 72.6935 73.0705 73.4021ZM69.3133 150.996L69.6214 151.139L107.194 89.8209H82.5613C76.437 89.8209 70.3052 89.8586 64.1885 89.8209C62.9873 89.8894 61.7857 89.6926 60.6686 89.2443C59.5516 88.796 58.5462 88.1072 57.7234 87.2265C56.9007 86.3458 56.2808 85.2947 55.9073 84.1473C55.5338 83 55.4159 81.7844 55.5619 80.5863C56.5914 72.3995 57.7185 64.2354 58.7931 56.0486C59.2289 52.7392 59.6272 49.4223 60.0405 46.1129C59.9202 46.0752 59.8 46.03 59.6798 45.9998L22.8139 106.157H25.2711C38.4139 106.157 51.5717 106.157 64.707 106.157C65.9412 106.049 67.1838 106.224 68.3404 106.67C69.4971 107.115 70.5374 107.819 71.3825 108.728C72.2276 109.637 72.8554 110.727 73.2182 111.915C73.5809 113.104 73.6692 114.36 73.4763 115.587C73.3636 117.306 73.1081 119.025 72.9052 120.744L69.3133 150.996Z"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_423_104"
                            x1="65.0324"
                            y1="0.0410156"
                            x2="65.0324"
                            y2="195.967"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stop-color="#02DDB5" />
                            <stop offset="1" stop-color="#03D078" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <span className="svg-green"></span>
                    </span>

                    <span>
                      <h5 className="msg1 msg">Battery Full</h5>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Images image={blade_19} className="top__margin" />
            {/* <Images image={blade_17} className="top__margin" /> */}
            <Images image={blade_20} className="top__margin" />
            <Images image={blade_21} className="top__margin" />
          </div>

          {/* end */}

          <PrevAndNextWork
            image1={prevImg}
            image2={nextImg}
            next="/work/informatic-press"
            prev="/work/itat"
          />
          <Footer />
        </div>
      </div>
    </div>
  );
};
export default VerdemobilityApp;
